<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
    style="enable-background: new 0 0 200 200"
    xml:space="preserve"
  >
    <rect style="fill: #ffffff" width="200" height="200" />
    <path
      style="fill: #464342"
      d="M57.1,100c0,17,9.9,31.7,24.2,38.6L60.8,82.5C58.4,88,57.1,94,57.1,100z M129,97.8
	c0-5.3-1.9-9-3.5-11.8c-2.2-3.5-4.2-6.5-4.2-10.1c0-3.9,3-7.6,7.2-7.6c0.2,0,0.4,0,0.6,0c-7.6-7-17.8-11.3-29-11.3
	c-15,0-28.2,7.7-35.8,19.3c1,0,2,0.1,2.8,0.1c4.5,0,11.4-0.5,11.4-0.5c2.3-0.1,2.6,3.3,0.3,3.5c0,0-2.3,0.3-4.9,0.4l15.6,46.5
	l9.4-28.2L92,79.9c-2.3-0.1-4.5-0.4-4.5-0.4c-2.3-0.1-2-3.7,0.3-3.5c0,0,7.1,0.5,11.3,0.5c4.5,0,11.4-0.5,11.4-0.5
	c2.3-0.1,2.6,3.3,0.3,3.5c0,0-2.3,0.3-4.9,0.4l15.5,46.1l4.3-14.3C127.5,105.8,129,101.5,129,97.8L129,97.8z M100.8,103.8
	l-12.9,37.4c3.9,1.2,8,1.7,12.1,1.7c5,0,9.8-0.9,14.2-2.4c-0.1-0.2-0.2-0.4-0.3-0.6L100.8,103.8L100.8,103.8z M137.6,79.4
	c0.2,1.4,0.3,2.8,0.3,4.4c0,4.4-0.8,9.2-3.3,15.4l-13.1,37.9c12.8-7.4,21.3-21.3,21.3-37.1C142.9,92.5,141,85.5,137.6,79.4
	L137.6,79.4z M100,50c-27.6,0-50,22.4-50,50c0,27.6,22.4,50,50,50c27.6,0,50-22.4,50-50C150,72.4,127.6,50,100,50L100,50z
	M100,147.7c-26.3,0-47.7-21.4-47.7-47.7c0-26.3,21.4-47.7,47.7-47.7c26.3,0,47.7,21.4,47.7,47.7C147.7,126.3,126.3,147.7,100,147.7
	z"
    />
  </svg>
</template>
<script>
export default {
  name: "IconWp",
};
</script>
